class JobStatus {
	static Invalid = 0;
	static Created = 1;
	static Preparing = 2;
	static Ready = 3;
	static Retry = 4;
	static Scheduled = 5;
	static Running = 6;
	static Completed = 7;
	static Error = 8;
	static Expired = 9;
	static K8Error = 10;
}

export default JobStatus;